import environment from "@/config/environment";
import { getToken } from "@/features/auth/jwt";
import { type DefaultEventsMap } from "@socket.io/component-emitter";
import EventBus from "js-event-bus";
import _ from "lodash";
import { useEffect } from "react";
import { io, Socket } from "socket.io-client";
import { useUser } from "../auth/hooks/use-user";

let ready = false;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let joined: any[] = [];
let socket: Socket<DefaultEventsMap, DefaultEventsMap> | null = null;

export const websocketBus = new EventBus();

websocketBus.on("join", (event) => {
  console.log("websockets join", event);
  if (!ready) joined.push(event);
});

export const useWebSockets = () => {
  const { data: user } = useUser();
  useEffect(() => {
    console.log("websockets", user?.id);
    if (user?.id) {
      const endpoint = environment.server
        .replace(/\/$/, "")
        .replace(/^http/, "ws");
      socket = io(endpoint + "/websockets", {
        reconnectionDelayMax: 10000,
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 5000,
        withCredentials: true,
        auth: {
          token: getToken(),
        },
      });

      socket.on("message", (event) => {
        websocketBus.emit(event.room, null, event);
      });

      socket.on("connect", () => {
        ready = true;
        console.log("🟢 Websockets connected");

        websocketBus.detach("join"); //Detach buffer
        websocketBus.on("join", (event) => {
          joined.push(event);
          if (socket) socket.emit("join", { room: event.room });
        });

        joined = _.uniqBy(joined, "room");
        console.log(
          `🔄 Re-joining ${joined.length} room(s):`,
          joined.map((j) => j.room),
        );
        joined.forEach(
          (event) => socket && socket.emit("join", { room: event.room }),
        );
      });

      socket.on("disconnect", (reason) => {
        ready = false;
        console.log("🔴 Websockets disconnected:", reason);

        // Reset handler to buffer mode during disconnect
        websocketBus.detach("join");
        websocketBus.on("join", (event) => {
          console.log("⏸️  Buffering join during disconnect:", event.room);
          if (!joined.some((j) => j.room === event.room)) {
            joined.push(event);
          }
        });
      });

      socket.on("reconnect", (attemptNumber) => {
        console.log(
          `🔄 Websockets reconnected after ${attemptNumber} attempt(s)`,
        );
      });

      socket.on("reconnect_attempt", (attemptNumber) => {
        console.log(`🔄 Websockets reconnect attempt #${attemptNumber}`);
      });

      socket.on("reconnect_error", (error) => {
        console.error("❌ Websockets reconnect error:", error.message);
      });

      socket.on("connect_error", (error) => {
        console.error("❌ Websockets connect error:", error.message);
      });
    } else {
      if (socket) socket.close();
      socket = null;
    }

    return () => {
      if (socket) socket.close();
      socket = null;
    };
  }, [user?.id]);
};
